import {
  HSPLITTER
} from '../common/config';
import {
  restartStaffcopDialogCtrl
} from '../admin/modals';
import {
  Filter
} from '../common/filter';
import {
  DIM2CLASS,
  TYPE2CLASS
} from '../core/icon-class';
import {
  Measure
} from '../common/measure';

require('./root.component.scss');

/*
 * Main analytics controller
 */
export class RootCtrl {

  constructor(
    $scope,
    $timeout,
    CurrentFilterService,
    CurrentModelService,
    RouterService,
    FiltersService,
    AggregateDataService,
    PermissionService,
    CurrentFilterDataService,
    CatalogNodeDragService,
    LocalStorageService,
    LayoutService,
  ) {
    $scope.currentFilter = CurrentFilterService;
    $scope.filterBar = CurrentFilterService.filterBar;
    $scope.currentModel = CurrentModelService;
    $scope.generateReport = RouterService.generateReport.bind(RouterService);
    $scope.locLabel = Filter.locLabel;
    $scope.FiltersService = FiltersService;
    $scope.permission = PermissionService;
    $scope.getMeasure = Measure.getMeasure;
    $scope.getMeasureLabel = Measure.getMeasureLabel;
    $scope.getMeasures = Measure.getMeasures;
    $scope.TYPE2CLASS = TYPE2CLASS;
    $scope.DIM2CLASS = DIM2CLASS;
    $scope.newFilter = () => RouterService.newFilter();
    $scope.getCellFilter = (...args) => CurrentModelService.model.getCellFilter(
      ...args);
    $scope.getCellLabel = (...args) => CurrentModelService.model.getCellLabel(
      ...args);
    $scope.setMeasure = RouterService.setMeasure.bind(RouterService);
    $scope.selectDim = RouterService.selectDim.bind(RouterService);
    $scope.removeDim = RouterService.removeDim.bind(RouterService);
    $scope.drilldown = RouterService.drilldown.bind(RouterService);
    $scope.router = RouterService;
    $scope.CatalogNodeDragService = CatalogNodeDragService;
    $scope.LayoutService = LayoutService;
    // $scope.localStorage = LocalStorageService;

    Object.defineProperty($scope, 'filter', {
      get: () => $scope.currentFilter.filter,
    });
    Object.defineProperty($scope, 'model', {
      get: () => $scope.currentModel.model,
    });
    Object.defineProperty($scope, 'cube', {
      get: () => $scope.currentModel.cube,
    });
    Object.defineProperty($scope, 'filters', {
      get: () => FiltersService.filters,
    });
    Object.defineProperty($scope, 'visibleDimensions', {
      get: () => $scope.currentFilter.visibleDimensions,
    });

    if ($scope.LayoutService.options.saveInterface.value) {
      const splitter1Pos = parseInt(LocalStorageService.getItem('splitter1', HSPLITTER), 0);
      const splitter2Pos = parseInt(LocalStorageService.getItem('splitter2', HSPLITTER / 2), 0);
      $scope.splitters = splitter1Pos ? [splitter1Pos] : [HSPLITTER];
      $scope.splitters.push(splitter2Pos ? splitter2Pos : HSPLITTER / 2);
    } else $scope.splitters = [HSPLITTER, HSPLITTER / 2];
    $scope.LayoutService.splitters = $scope.splitters;

    /* Escape loading */
    $('#image-spinner-cancel').on('click', function() {
      $('#image-spinner').hide();
    });

    window.updateSize = function() {
      $scope.$root.$broadcast('resize');
    };

    // TODO: find out the reason for the appearance of nulls in url
    window.onhashchange = function() {
      if (window.location.href.match(/\/#!\/null\?/)) {
        console.error('wrong url:', window.location.href);
        window.location.assign(window.location.href.replace(/\/#!\/null\?/, '/#!/?'));
      }
    };

    window.addEventListener('resize', function() {
      $scope.$root.$broadcast('resize');
    });

    window.addEventListener('sortTimeTracker', (e, p) => {
      // console.log(e, p);
    });

    window.onmousedown = () => window.isMouseDown = true;
    window.onmouseup = () => window.isMouseDown = false;

    window.addEventListener('mouseup', e => {
      if (e && (e.which == 2 || e.button == 4)) {
        const oldUrl = window.location.href;
        let newUrl = oldUrl;
        $(e.target).click();
        $timeout(() => {
          newUrl = window.location.href;
          window.location.href = oldUrl;
          const win = window.open(newUrl);
        }, 100);
      }
    });

    window.addEventListener('keyup', function(e) {
      if (e.ctrlKey && e.keyCode === 90) {
        if ($scope.router.layout.editCatalog) {
          $scope.CatalogNodeDragService.keyUp(e);
          e.preventDefault();
        }
      } else if (e.ctrlKey && e.shiftKey && (e.key === 'L' || e.key === 'l')) {
        $scope.LayoutService.openOptions();
      } else if (e.ctrlKey && e.shiftKey && (e.key === 'S' || e.key === 's')) {
        $scope.LayoutService.openServerInfo();
      }
    });

    $scope.$on('reload', () => {
      if ($scope.currentFilter.lastScreenshots)
        $scope.currentFilter.lastScreenshots = {
          timeFrom: $scope.currentFilter.timeFrom
        };
      CurrentFilterDataService.reload(true);
    });

    window.addFilter = (name, value, label) => {
      if (!name || !value) return;
      $scope.router.addFilter(name, value, label);
      $timeout(() => {}, 10);
      return false;
    };

    window.selectFilter = (name, value, label) => {
      if ((!name || !value) && value !== '') return;
      $scope.router.cleanFilter(name, value, label);
      $scope.router.addFilter(name, value, label);
      // $timeout(() => {}, 10);
      return false;
    };

    window.setPeriod = (timeFrom, timeTo) => {
      $scope.router.timeFrom = timeFrom;
      $scope.router.timeTo = timeTo;
    };

    // window.drilldownFilter = (dimension, value, label) => {
    window.drilldownFilter = (...args) => {
      $scope.router.drilldownFilter(...args);
      // $timeout(() => {}, 10);
      return false;
    };

    window.drilldownFilter2 = (...args) => {
      $scope.router.drilldownFilter2(...args);
      // $timeout(() => {}, 10);
      return false;
    };

    window.drilldownFilterHTML = (...args) => {
      $scope.router.drilldownFilterHTML(...args);
      // $timeout(() => {}, 10);
      return false;
    };

    window.drilldownCut = (...args) => {
      $scope.router.drilldownCut(...args);
      // $timeout(() => {}, 10);
      return false;
    };

    window.removeCut = (...args) => {
      $scope.router.removeCut(...args);
      $timeout(() => {}, 10);
      return false;
    };

    window.changeCut = (...args) => {
      $scope.router.changeCut(...args);
      $timeout(() => {}, 10);
      return false;
    };


    window.mode = function(mode) {
      $scope.router.mode = mode;
      $scope.$root.$digest();
    };

    window.reload = function() {
      $scope.$root.$broadcast('reload');
    };

    window.setCellFilter = (drill, cell) => {
      const filter = $scope.getCellFilter(drill, cell);
      $scope.router.toggleFilter(filter);
      $scope.currentFilter.rebuildVisibleDimensions();
      $scope.router.filterChanged();
    };

    $('[data-toggle=\'tooltip\']').tooltip();

    window.changeThreshold = (thresholdTag) => {
      const threshold = thresholdTag.value;
      if (!threshold || threshold < 1) {
        return;
      }
      RouterService.threshold = threshold;
      RouterService.update();
      window.reload();
    };

    $scope.router.init();
  }
}



// WEBPACK FOOTER //
// ./src/layout/root.js